import {
  Home,
  CheckSquare,
  User,
  Building2,
  DollarSign,
  Folder,
  Megaphone,
  Play,
  Package,
  GraduationCap,
  Info,
  LogOut,
  Plus,
  Globe,
  BarChart2,
  Gift,
  UserPlus,
  Users,
  Download,
  KeyRound,
  HelpCircle,
  ListFilter,
  ChevronDown,
  Search,
  ChevronRight,
  Circle,
  TriangleAlert,
  BookOpen,
  ShieldCheck,
  RefreshCw,
  Ban,
  BookMarked,
  Star,
  ShieldAlert,
  ExternalLink,
  BookSearch,
  ShieldUser,
  ListTree,
  BookCheck,
  Blocks,
  MonitorCog,
  ClipboardCheck,
  Wrench,
  LibraryBig,
  Clock
} from 'lucide-react';

const icons = {
  home: Home,
  actionItems: CheckSquare,
  agentInfo: User,
  myAppointments: ShieldCheck,
  resources: BookSearch,
  commissions: DollarSign,
  files: Folder,
  marketing: Megaphone,
  videos: Play,
  oMProducts: Package,
  learning: GraduationCap,
  info: Info,
  logOut: LogOut,
  plus: Plus,
  web: Globe,
  commissionRates: BarChart2,
  bonus: Gift,
  lead: UserPlus,
  people: Users,
  agency: Building2,
  download: Download,
  resetPassword: KeyRound,
  question: HelpCircle,
  filterList: ListFilter,
  arrowDropDown: ChevronDown,
  search: Search,
  arrowRight: ChevronRight,
  circle: Circle,
  warning: TriangleAlert,
  book: BookOpen,
  policy: ShieldUser,
  refresh: RefreshCw,
  doNotDisturb: Ban,
  menuBook: BookMarked,
  wrench: Wrench,
  libraryBig: LibraryBig,
  clock: Clock,
  grade: Star,
  riskManagement: ShieldAlert,
  openInNew: ExternalLink,
  library: BookOpen,
  agencyDashboard: Blocks,
  agencyHierarchy: ListTree,
  agencyAppointments: BookCheck,
  agencySettings: MonitorCog,
  onboardingDashboard: ClipboardCheck
};

export default icons;

export const baseDangerLinkClass =
  '[&_svg]:!text-[var(--color-semantic-danger)] hover:[&_svg]:!text-[var(--color-semantic-danger)]';
